<template>
  <div>
    <a
        href="javascript:;"
        data-toggle="modal"
        data-target="#warning-modal-preview"
        style="display: none"
        id="show-modal"
        class="button inline-block bg-theme-1 text-white"
    >Show Modal</a
    >
    <div id="warning-modal-preview" class="modal">
      <div class="modal__content">
        <div class="p-5 text-center">
          <xCircleIcon class="w-16 h-16 text-theme-12 mx-auto mt-3" />
          <div class="text-3xl mt-5">Oops...</div>
          <div class="text-gray-600 mt-2">{{modalText}} </div>
        </div>
        <div class="px-5 pb-8 text-center">
          <button
              type="button"
              data-dismiss="modal"
              class="button w-24 bg-theme-1 text-white"
          >
            Ok
          </button>
        </div>
        <div
            class="p-5 text-center border-t border-gray-200 dark:border-dark-5"
        >
        </div>
      </div>
    </div>
    <div class="grid grid-cols-12 gap-6 mt-5">
      <div class="intro-y col-span-12 lg:col-span-6">
        <!-- BEGIN: Vertical Form -->
        <div class="intro-y box">
          <div
            class="flex flex-col sm:flex-row items-center p-5 border-b border-gray-200 dark:border-dark-5"
          >
            <h2 class="font-medium text-base mr-auto">
              Convert your pdf to an editable excel file for ${{ settings[0].product_price }} excluding GST
            </h2>
          </div>
          <div id="vertical-form" class="p-5">
            <div class="uk-margin">
              <div>
                <br />

                Confirmation:


                Your are about to submit the PMST file {{
                  file.filename
                }} for conversion.


                Hit the submit button below to confirm.
                Once pressed your preferred payment method will be charged.


                Following conversion you will receive an email to your registered
                email address with the editable excel file and tax invoice attached.
              </div>
              <br />
              <br />
              <br />
            </div>
            <div class="preview">
              <div class="uk-margin">
                <label for="card">Enter credit card details for payment via Stripe secure payment platform.</label>
                <br />
                <br />
                <Card
                  ref="card-stripe"
                  stripe="pk_live_51HWzrUEA9xUuguSeftLDF2XLI8i2E9oRsZmlDWKFk5GNcivJjSuYZDSZwETb54m2lPyBwImQiJkc0Kvk5hPN2u8W00WOexXWD2"
                  @change="complete = $event.complete"
                />
              </div>
              <br />
              <div v-if="!loading">
                <button
                    type="button"
                    class="button bg-theme-1 text-white mt-5"
                    @click="handleSubmit"
                >
                  Submit
                </button>
              </div>
              <br />
              <div v-if="loading">
                <button
                    class="button w-24 inline-block mr-1 mb-2 bg-theme-1 text-white inline-flex items-center"
                >
                  Loading
                  <LoadingIcon
                      icon="oval"
                      color="white"
                      class="w-4 h-4 ml-auto"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- END: Vertical Form -->
      </div>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { Card, createToken } from "vue-stripe-elements-plus";
import axios from "axios";
export default {
  components: {
    Card
  },
  data: function() {
    return {
      settings: [
        {
          product_price: undefined
        }
      ],
      modalText: "",
      file: {
        filename: null
      },
      load: false,
      card: {
        cvc: "",
        number: "",
        expiry: ""
      },

      //elements
      cardNumber: "",
      cardExpiry: "",
      cardCvc: "",
      stripe: null,

      // errors
      stripeError: "",
      cardCvcError: "",
      cardExpiryError: "",
      cardNumberError: "",

      loading: false
    };
  },

  mounted() {
    this.getFile()
    this.getSettings()
  },

  methods: {
    getSettings() {
      axios
          .get("pmst/settings/")
          .then(response => {
            let data = response.data;
            this.settings = data;
          })
          .catch(function(error) {
            console.error(error.response);
          });
    },
    getFile() {
      // this.user = localStorage.getItem("user");
      // console.log("USEREEE");
      // console.log(this.user);
      axios
          .get("file/" + this.$route.params.fileId)
          .then(response => {
            let data = response.data;
            this.file = data[0];
          })
          .catch(function(error) {
            console.error(error.response);
          });
    },
    async handleSubmit() {
      let fileId = this.$route.params.fileId;
      // console.log(fileId);
      // console.log("Submit");
      this.loading = true;
      // eslint-disable-next-line no-unused-vars
      let token;
      try {
        const response = await createToken();
        token = response.token.id;
        // console.log(token);
      } catch (err) {
        // console.log(err);
        this.modalText = "Error: Please check your correct credit card details. If this error continues please contact us"
        document.getElementById("show-modal").click()
        this.loading = false;
        return;
      }
      try {
        // eslint-disable-next-line no-unused-vars
        let resp = await axios.post("paid/stripe/", {
          token: token,
          file_id: fileId
        });
        if (resp.data.status === "err") {
          if (resp.data.status === "stripe error") {
            this.modalText = "Error: Stripe is currently offline. Please, try again later or contact us"
            document.getElementById("show-modal").click()
          } else {
            this.modalText = "Error: Something went wrong. Please check your credit card details. If this error continues please contact us"
            document.getElementById("show-modal").click()
          }
        } else {
          this.$router.push("/success");
        }
        this.loading = false;
        // console.log(resp);
        // alert("Your order have been successfully submitted.");
      } catch (err) {
        this.loading = false;
        alert("Something went wrong. Please contact us.");
      }
    }
  }
};
</script>

<style>
[v-cloak] {
  display: none;
}

.help-block {
  color: red;
  font-size: 13px;
}

form {
  border-width: 2px;
  border-style: solid;
  border-color: yellow;
}

label.uk-form-label {
  color: blue;
}

button.uk-button-primary {
  color: yellow;
  font-weight: bold;
  background-color: #1e87f0;
}

#card-number,
#card-cvc,
#card-expiry {
  padding-top: 10px;
}

.stripeError {
  color: red;
  font-style: italic;
}
</style>
